// extracted by mini-css-extract-plugin
export default {"languages_row":"languages_languages_row__4BcvS","Languages_head_text":"languages_Languages_head_text__iw+6a"};